module.exports = __webpack_public_path__ + "img/product24-nongmaodianshang.8743471d.svg";